export default "__VITE_ASSET__be654850__"